import React from 'react';
import { PhaseTypeEnum } from '@vatos-pas/common';
import { LocationStatusIcon } from 'components/LocationDetail';
import { PermissionsProvider } from 'providers/permissionsProvider';
import { AppRole } from 'providers/roles';
import { getPhaseByType, isStartingApprovedPhase } from 'utils/phaseUtils';
import { getLocationVariantForPhase } from '../../utils/getLocationVariantForPhase';
import { formatJobAddress } from '../../utils/formatJobAddress';

interface PhaseApprovedGeoIconProps {
  phaseType: PhaseTypeEnum;
  selectedJob: any;
}

export const PhaseApprovedGeoIcon: React.FC<PhaseApprovedGeoIconProps> = ({
  phaseType,
  selectedJob,
}) => {
  const { hasRole } = PermissionsProvider.useContainer();
  const isSuperAdmin = hasRole(AppRole.SuperAdmin);
  const approvedPhase = getPhaseByType(selectedJob?.jobPhases, phaseType);

  if (
    !isSuperAdmin ||
    !approvedPhase ||
    !approvedPhase.dateApproved ||
    isStartingApprovedPhase(approvedPhase, selectedJob)
  ) {
    return null;
  }

  return (
    <LocationStatusIcon
      variant={getLocationVariantForPhase(
        phaseType,
        selectedJob?.job?.reqBumpoutTimesheet,
      )}
      timestamp={approvedPhase.dateApproved}
      geo={approvedPhase.approvedGeo}
      status={approvedPhase.approvedGeoStatus}
      distance={approvedPhase.approvedGeoCalculatedDistance}
      userName={approvedPhase.approvingUserFullName}
      address={formatJobAddress(selectedJob.job)}
      jobGeo={selectedJob?.job?.jobGeo ?? null}
    />
  );
};
